export const sid = "cbpihhnzfctayluhnyxn";
export const environment = {
  production: true,
  supabaseUrl: 'https://' + sid + '.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNicGloaG56ZmN0YXlsdWhueXhuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU3MjAzOTgsImV4cCI6MjA5MTI5NjM5OH0.knncbWhO3AI9oF0sx6U4yshEbieMouq-YTJ04SbyrkA',
  vehicleVisualsUrlNoPartId: 'https://iqmotive.vehiclevisuals.com/thirdpartyapi/#!/viewAnimation/PARTNUMBERHERE?show_menu=0&is_interactive=0&show_left_sidebar=0&show_description=0&video_only=1&auto_play=0',
  SettingsExpiretime: 600000, // 10*60*1000 = 10 minutes
  logoUrl: 'https://' + sid + '.supabase.co/storage/v1/object/public/internaldesign/companylogo.png',
  osbUrl: 'https://osb.hasa.serviceiqglobal.com',
  osbFrontendUrl: 'https://osb.hasa.serviceiqglobal.com',
  internalfileUrl: 'https://' + sid + '.supabase.co/storage/v1/object/public/internaldesign/',
  portalUrl: 'https://vhcportal.hasa.serviciqglobal.com',
};